import { createApi } from '@reduxjs/toolkit/query/react';
import { btBaseQuery } from 'src/Common/common';

// Define the API service for ORECutting
export const oreCuttingApi = createApi({
  reducerPath: 'oreCuttingApi',
  baseQuery: btBaseQuery,
  tagTypes: ['Cutting'], // Define the tag type for cache management and invalidation
  endpoints: (builder) => ({
    // Define the endpoints for your API
    findAllCuttings: builder.query({
      query: (company) => `cutting/${company}`, // GET all cutting entries by company
      providesTags: ['Cutting'] // Cache with the 'Cutting' tag
    }),
    findCuttingById: builder.query({
      query: (id) => `cutting/byid/${id}`, // GET cutting entry by ID
      providesTags: ['Cutting'] // Cache with the 'Cutting' tag
    }),
    insertCutting: builder.mutation({
      query: (cutting) => ({
        url: 'cutting', // POST a new cutting entry
        method: 'POST',
        body: cutting
      }),
      invalidatesTags: ['Cutting'] // Invalidate the 'Cutting' tag cache
    }),
    updateCutting: builder.mutation({
      query: (cutting) => ({
        url: 'cutting', // PUT update cutting entry
        method: 'PUT',
        body: cutting
      }),
      invalidatesTags: ['Cutting'] // Invalidate the 'Cutting' tag cache
    }),
    deleteCutting: builder.mutation({
      query: (id) => ({
        url: `cutting/${id}`, // DELETE a cutting entry by ID
        method: 'DELETE'
      }),
      invalidatesTags: ['Cutting'] // Invalidate the 'Cutting' tag cache
    })
  })
});

// Export the auto-generated hooks for the endpoints
export const {
  useFindAllCuttingsQuery,
  useFindCuttingByIdQuery,
  useInsertCuttingMutation,
  useUpdateCuttingMutation,
  useDeleteCuttingMutation
} = oreCuttingApi;
